import { useMemo } from 'react';
import { useReviewService, type Product } from '@skin-seoul/service';
import { createProductReviewStatsMap, extractProductIdsForReviews } from '../../utils/collectionProductDataHelpers';

/**
 * Shared hook for fetching and processing product review statistics
 * Used by both useProductGridData and useSearchProductGridData
 */
export const useProductReviewData = (products: Product[]) => {
  const { useGetReviewStatistics } = useReviewService();

  // Extract product IDs for review statistics
  const productIdsForReviews = useMemo(() => {
    return extractProductIdsForReviews(products);
  }, [products]);

  // Fetch review statistics
  const { data: reviewStats } = useGetReviewStatistics({
    productIds: productIdsForReviews,
  });

  // Create review statistics map
  const reviewStatsMap = useMemo(() => {
    return createProductReviewStatsMap(reviewStats);
  }, [reviewStats]);

  return {
    reviewStatsMap,
    productIdsForReviews,
    reviewStats,
  };
};
